import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { EditTeamsForm } from 'local/components'
import { TeamAthletes } from 'local/components/teamAthletes'
import { AddAthleteButton } from 'local/components/addAthleteButton'
import { BaseModal } from 'shared/components'
import { colors } from 'styles/variables'

const TeamsUpdateComponent = ({ onSubmit, getTeamInfoById, teamId }) => {
  const [initialValues, setInitialValues] = useState('')
  useEffect(() => {
    getTeamInfoById(teamId).then((response) => {
      setInitialValues(response)
    })
  }, [])

  const modalStyle = {
    content: {
      maxHeight: '80%',
      background: colors.grays.gray6,
    },
  }

  const Trigger = (onTrigger) => {
    return <AddAthleteButton onTrigger={onTrigger} />
  }
  const Body = (onRequestClose) => {
    return <TeamAthletes onRequestClose={onRequestClose} />
  }
  return (
    <>
      {initialValues && (
        <>
          <EditTeamsForm
            header="Update Team"
            onSubmit={onSubmit}
            initialValues={initialValues}
          />
          <BaseModal
            style={modalStyle}
            renderTrigger={Trigger}
            renderBody={Body}
          ></BaseModal>
        </>
      )}
    </>
  )
}

TeamsUpdateComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  getTeamInfoById: PropTypes.any,
  teamId: PropTypes.any,
}

export default TeamsUpdateComponent
